import React, { useState, useEffect, useRef } from "react";
import Layout from "../../Common/Layout";
import ContactInformationConfig from "./ContactInformation";
import DriverInformationConfig from "./DriverInformation";
import PolicyInformationConfig from "./PolicyInformation";
import VehicleInformationConfig from "./VehicleInformation";
import CompareInsuranceQuotesConfig from "./CompareInsuranceQuotes";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import axios from "axios";
export default function Configuration() {
  const tabs = [
    { id: "contact", label: "Contact Information" },
    { id: "driver", label: "Driver Information" },
    { id: "vehicle", label: "Vehicle Information" },
     { id: "policy", label: "Policy Information" },
    { id: "quotes", label: "Compare Insurance Quotes" },
  ];

  // Example: state-wise config values for each tab (to be replaced with API data)
  const stateConfigs: {
    [key: string]: {
      contact?: any;
      driver?: any;
      policy?: any;
      vehicle?: any;
      quotes?: any;
    };
  } = {
    AL: {
      contact: {},
      driver: {},
      policy: {},
      vehicle: {},
      quotes: {},
    },
    FL: {
      contact: {},
      driver: {},
      policy: {},
      vehicle: {},
      quotes: {},
    },
    GA: {},
    OH: {},
    SC: {},
    TN: {},
  };

  const states = [
    { value: "", name: "Select a state" },
    { value: "Alabama", name: "Alabama" },
    { value: "Florida", name: "Florida" },
    { value: "Georgia", name: "Georgia" },
    { value: "Ohio", name: "Ohio" },
    { value: "South Carolina", name: "South Carolina" },
    { value: "Tennessee", name: "Tennessee" },
  ];

  const [selectedState, setSelectedState] = useState<string>(states[0].value);
  const [activeTab, setActiveTab] = useState<string>(tabs[0].id);
  const toast = useRef<Toast | null>(null);
  const [contactLoading, setContactLoading] = useState(false);
  const [contactConfigurationList, setContactConfigurationList] = useState(false);
  const [driverConfigurationList, setDriverConfigurationList] = useState(false);
  const [driverLoading, setDriverLoading] = useState(false);
  const [vehicleConfigurationList, setVehicleConfigurationList] = useState(false);
  const [vehicleLoading, setVehicleLoading] = useState(false);
  const [policyInformationConfigurationList, setPolicyInformationConfigurationList] = useState(false);
  const [policyLoading, setPolicyLoading] = useState(false);
  const [compareInsuranceQuoteConfigurationList, setCompareInsuranceQuoteConfigurationList] = useState(false);
  const [compareInsuranceQuoteLoading, setCompareInsuranceQuoteLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (selectedState && selectedState.trim() !== "") {
      getContactConfigurationDetails();
      getDriverConfigurationDetails();
      getVehicleConfigurationDetails();
      getPolicyInformationConfigurationDetails();
      getCompareInsuranceQuoteConfigurationDetails();
    }
  }, [selectedState]);

  const getContactConfigurationDetails = () => {
    setContactLoading(true);
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ACE_API_Url}/api/ace/contactinformationconfiguration?state=${selectedState}  `,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "Application/json",
      },
    })
      .then((response: any) => {
        setContactConfigurationList(response.data);
        setContactLoading(false);
      })
      .catch((error: any) => {
        setContactLoading(false);
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response && error.response.status
                ? `Error ${error.response.status}: ${error.response.data?.message || "An error occurred while searching the client!"}`
                : "Unknown error while getting  the contact configuration details!",
            life: 3000,
          });
        }
      });
  };
  const getDriverConfigurationDetails = () => {
    setDriverLoading(true);
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ACE_API_Url}/api/ace/driverinformationconfiguration?state=${selectedState}  `,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "Application/json",
      },
    })
      .then((response: any) => {
        setDriverConfigurationList(response.data);
        setDriverLoading(false);
      })
      .catch((error: any) => {
        setDriverLoading(false);
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response && error.response.status
                ? `Error ${error.response.status}: ${error.response.data?.message || "An error occurred while searching the client!"}`
                : "Unknown error while getting  the driver configuration details!",
            life: 3000,
          });
        }
      });
  };
  const getVehicleConfigurationDetails = () => {
    setVehicleLoading(true);
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ACE_API_Url}/api/ace/vehicleinformationconfiguration?state=${selectedState}  `,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "Application/json",
      },
    })
      .then((response: any) => {
        setVehicleConfigurationList(response.data);
        setVehicleLoading(false);
      })
      .catch((error: any) => {
        setVehicleLoading(false);
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response && error.response.status
                ? `Error ${error.response.status}: ${error.response.data?.message || "An error occurred while searching the client!"}`
                : "Unknown error while getting  the vehicle configuration details!",
            life: 3000,
          });
        }
      });
  };
  const getPolicyInformationConfigurationDetails = () => {
    setPolicyLoading(true);
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ACE_API_Url}/api/ace/policyinformationconfiguration?state=${selectedState}  `,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "Application/json",
      },
    })
      .then((response: any) => {
        setPolicyInformationConfigurationList(response.data);
        setPolicyLoading(false);
      })
      .catch((error: any) => {
        setPolicyLoading(false);
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response && error.response.status
                ? `Error ${error.response.status}: ${error.response.data?.message || "An error occurred while searching the client!"}`
                : "Unknown error while getting  the policy information configuration details!",
            life: 3000,
          });
        }
      });
  };
  const getCompareInsuranceQuoteConfigurationDetails = () => {
    setCompareInsuranceQuoteLoading(true);
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ACE_API_Url}/api/ace/compareinsurancequoteconfiguration?state=${selectedState}  `,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "Application/json",
      },
    })
      .then((response: any) => {
        setCompareInsuranceQuoteConfigurationList(response.data);
        setCompareInsuranceQuoteLoading(false);
      })
      .catch((error: any) => {
        setCompareInsuranceQuoteLoading(false);
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response && error.response.status
                ? `Error ${error.response.status}: ${error.response.data?.message || "An error occurred while searching the client!"}`
                : "Unknown error while getting  the compare insurance quote configuration details!",
            life: 3000,
          });
        }
      });
  };
  return (
    <Layout currentPage="Configuration">
      <Toast ref={toast} />

      <div className="page-container">
        <div className="page-header">
          <div className="page-header-content">
            <div className="page-title-section">
              <h1>Configuration</h1>
              <span className="title-separator">|</span>
              <p>Manage application settings and preferences</p>
            </div>
          </div>
        </div>

        {/* State Dropdown only */}
        <div className="state-dropdown-row">
          <div className="state-dropdown-group">
            <label htmlFor="state-select" className="state-dropdown-label">
              State
            </label>
            <select id="state-select" value={selectedState} onChange={(e) => setSelectedState(e.target.value)} className=" form-input compact-select">
              {states.map((state) => (
                <option key={state.value} value={state.value}>
                  {state.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="header-btn-group" style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
          {tabs.map((t) => (
            <button
              key={t.id}
              type="button"
              className={`btn ${activeTab === t.id ? "btn-primary" : "btn-secondary"}`}
              onClick={() => setActiveTab(t.id)}
              aria-pressed={activeTab === t.id}
              style={{ padding: "0.5rem 0.75rem" }}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="content-section" style={{ marginTop: "1rem" }}>
          {activeTab === "contact" && (
            <ContactInformationConfig
              state={selectedState}
              contactConfigurationList={contactConfigurationList}
              getContactConfigurationDetails={getContactConfigurationDetails}
              loading={contactLoading}
            />
          )}
          {activeTab === "driver" && (
            <DriverInformationConfig
              state={selectedState}
              driverConfigurationList={driverConfigurationList}
              getDriverConfigurationDetails={getDriverConfigurationDetails}
              loading={driverLoading}
            />
          )}
          {activeTab === "policy" && (
            <PolicyInformationConfig
              state={selectedState}
              policyInformationConfigurationList={policyInformationConfigurationList}
              getPolicyInformationConfigurationDetails={getPolicyInformationConfigurationDetails}
              loading={policyLoading}
            />
          )}
          {activeTab === "vehicle" && (
            <VehicleInformationConfig
              state={selectedState}
              vehicleConfigurationList={vehicleConfigurationList}
              getVehicleConfigurationDetails={getVehicleConfigurationDetails}
              loading={vehicleLoading}
            />
          )}
          {activeTab === "quotes" && (
            <CompareInsuranceQuotesConfig
              state={selectedState}
              compareInsuranceQuoteConfigurationList={compareInsuranceQuoteConfigurationList}
              getCompareInsuranceQuoteConfigurationDetails={getCompareInsuranceQuoteConfigurationDetails}
              loading={compareInsuranceQuoteLoading}
            />
          )}
        </div>
      </div>
    </Layout>
  );
}
